module.exports = __webpack_public_path__ + "img/sdc_pic_2.a1e4b2ae.jpg";